export default __webpack_public_path__ + "static/EntecresLabs-f11880ecf6e941a9fc2630b33c968c8c.jpg";